/**
 * On-demand load of Ingestro v4 vanilla SDK from the CDN (ES module script injected at runtime).
 * Keeps importer code out of the main webpack bundle. Pin version here and in `ingestroPublicTypes.ts` when upgrading.
 */
const INGESTRO_IMPORTER_VERSION = '4.2.4';
const INGESTRO_MODULE_URL = `https://unpkg.com/@ingestro/importer-vanilla-js@${INGESTRO_IMPORTER_VERSION}`;
const SCRIPT_ID = 'ingestro-vanilla-bootstrap';

let loadPromise: Promise<void> | null = null;

/** Test-only: clear module state between Jest cases. */
export function resetIngestroVanillaLoaderForTests(): void {
	loadPromise = null;
}

export function getLaunchDataImporter(): Promise<NonNullable<Window['__ingestroLaunchDataImporter']>> {
	if (window.__ingestroLaunchDataImporter) {
		return Promise.resolve(window.__ingestroLaunchDataImporter);
	}
	if (!loadPromise) {
		loadPromise = new Promise((resolve, reject) => {
			const onReady = (): void => {
				window.removeEventListener('ingestro-vanilla-ready', onReady);
				if (window.__ingestroLaunchDataImporter) {
					resolve();
				} else {
					loadPromise = null;
					reject(new Error('Ingestro vanilla loaded but launchDataImporter is missing'));
				}
			};
			window.addEventListener('ingestro-vanilla-ready', onReady);

			if (!document.getElementById(SCRIPT_ID)) {
				const script = document.createElement('script');
				script.id = SCRIPT_ID;
				script.type = 'module';
				script.textContent = `
import { launchDataImporter } from ${JSON.stringify(INGESTRO_MODULE_URL)};
window.__ingestroLaunchDataImporter = launchDataImporter;
window.dispatchEvent(new Event('ingestro-vanilla-ready'));
`.trim();
				script.onerror = (): void => {
					window.removeEventListener('ingestro-vanilla-ready', onReady);
					loadPromise = null;
					reject(new Error('Failed to load Ingestro vanilla module'));
				};
				document.head.appendChild(script);
			}
		});
	}
	return loadPromise.then(() => {
		const launch = window.__ingestroLaunchDataImporter;
		if (!launch) {
			throw new Error('Ingestro vanilla: launchDataImporter missing after load');
		}
		return launch;
	});
}
